import { createRouter, createWebHashHistory } from 'vue-router'
import { constantRouterMap } from '@/config/router.config'

const router = createRouter({
  history: createWebHashHistory(),
  routes: constantRouterMap,
})

// keep push behaviour similar to Vue2 (swallow NavigationDuplicated)
const originalPush = router.push
router.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject)
  }
  return originalPush.call(this, location).catch((err) => err)
}

export default router
